import { useParams } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function BlogPostPage() {
  const { slug, lng } = useParams();
  const { i18n } = useTranslation();
  const post = blogPosts.find(p => p.slug === slug);
  if (!post) return <main><p>Not found</p></main>;
  const isSr = (lng || i18n.language).startsWith('sr');
  const title = isSr ? post.title_sr : post.title_en;
  const content = isSr ? post.content_sr : post.content_en;

  return (
    <main>
      <Helmet>
        <title>{title} | Blog</title>
        <meta name="description" content={content.slice(0, 150)} />
      </Helmet>
      <article style={{ maxWidth: 820, margin: '0 auto', textAlign: 'left' }}>
        <header style={{ textAlign: 'center', marginBottom: 16 }}>
          <h1 style={{ marginBottom: 8 }}>{title}</h1>
          <p style={{ color:'#64748b' }}>{isSr ? 'Inspiracija i korisni saveti za bezbrižnu selidbu.' : 'Inspiration and practical tips for a smooth move.'}</p>
        </header>
        <figure style={{ margin: '0 0 16px' }}>
          <img src={process.env.PUBLIC_URL + post.image} alt={title} style={{ width:'100%', maxHeight: 380, objectFit: 'cover', borderRadius: 12, display:'block' }} />
        </figure>
        <p style={{ marginTop: 16, lineHeight: 1.7 }}>{content}</p>
        <p style={{ marginTop: 12, lineHeight: 1.7, color:'#334155' }}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent non erat urna. Cras at felis id nibh pretium interdum. Integer ut nibh eu nisl varius venenatis non et augue.
        </p>
        <p style={{ marginTop: 12, lineHeight: 1.7, color:'#334155' }}>
          Donec vitae nunc ac lorem feugiat facilisis. Sed luctus, enim quis faucibus varius, nibh sapien efficitur mauris, vitae imperdiet arcu risus id erat. Curabitur viverra, massa nec aliquet tempus, sem magna fringilla velit, ut tincidunt velit turpis vitae augue.
        </p>
      </article>
    </main>
  );
}
